enum SortDirection {
    ASCENDING = 'Ascending',
    DESCENDING = 'Descending',
}

export default SortDirection;
